import { render } from "./InterconsultaDestinoForm.vue?vue&type=template&id=25467736&scoped=true"
import script from "./InterconsultaDestinoForm.vue?vue&type=script&lang=js"
export * from "./InterconsultaDestinoForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=25467736&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25467736"]])

export default __exports__